export const widgetSearchParamKeys = {
  indicator: 'indicator',
};

export const widgetPaths = {
  searchAsset: 'searchAsset',
  watchlistManagerModal: 'watchlistManagerModal',
  editWatchlistModal: 'editWatchlistModal',
} as const;

export type WidgetPathNames = (typeof widgetPaths)[keyof typeof widgetPaths];
